export default __webpack_public_path__ + "static/media/1.0c4186e1.jpg";